import { render } from "./HeroMemberDetails.vue?vue&type=template&id=70661fa2&scoped=true"
import script from "./HeroMemberDetails.vue?vue&type=script&lang=js"
export * from "./HeroMemberDetails.vue?vue&type=script&lang=js"

import "./HeroMemberDetails.vue?vue&type=style&index=0&id=70661fa2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70661fa2"]])

export default __exports__